import React from "react";
import useReveal from "../hooks/useReveal";
import PageHero from "../components/PageHero";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";

export default function ReviewsPage() {
  useReveal();
  return (
    <>
      <PageHero eyebrow="Reviews" title="Loved by Our Clients" subtitle={"Rated 5.0\u2605 on Google - here's what our VIIMII family has to say."} />
      <Testimonials />
      <FAQ />
    </>
  );
}
